import "./style.css"

export function NotFoundPage (){
    return <>
    <img className="notfound-page" src="https://www.valuehost.com.br/blog/wp-content/uploads/2022/01/post_thumbnail-77d8f2a95f2f41b5863f3fba5a261d7e.jpeg.webp" alt="" />
    </>
}

